module.exports = __webpack_public_path__ + "static/media/400041_01.9544e237.png";